module.exports = __webpack_public_path__ + "img/mexercises.30fd4dfd.svg";